// src/store/services/uploadApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const uploadApi = createApi({
  reducerPath: "uploadApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API, // ✅ => /api/upload
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // ✅ POST /api/upload  (single)
    uploadSingle: builder.mutation({
      query: ({ path, file }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: `${path}/upload`, // baseUrl = .../upload
          method: "POST",
          body: formData,
          // ❌ Content-Type رو دستی نذار؛ مرورگر boundary می‌ذاره
        };
      },
      transformResponse: (res) => res,
    }),

    // ✅ POST /api/upload/multi (multiple)
    uploadMultiple: builder.mutation({
      query: ({path, files}) => {

        const formData = new FormData();
        (files || []).forEach((f) => formData.append("files", f));

        return {
          url: `${path}/upload/multi`,
          method: "POST",
          body: formData,
        };
      },
      transformResponse: (res) => res?.data ?? res,
    }),

    // ✅ POST /api/upload/remove
    removeFile: builder.mutation({
      query: (path, filename) => ({
        url: `${path}/upload/remove`,
        method: "POST",
        body: { filename },
        headers: { "Content-Type": "application/json" },
      }),
      transformResponse: (res) => res,
    }),
  }),
});

export const {
  useUploadSingleMutation,
  useUploadMultipleMutation,
  useRemoveFileMutation,
} = uploadApi;
